// messages は翻訳済みの 1 文字列（例「7日前15時以降：宿泊料金の10%」）で受け取るため、
// 文言を変えずに表の 2 セルへ分けるには区切りで割る。en は "15:00" を含むので ": " で判定する
const RULE_SEPARATOR = /：|: /;

export const splitCancelFeeRule = (
  rule: string,
): { period: string; value: string } => {
  const match = RULE_SEPARATOR.exec(rule);
  if (!match) return { period: rule, value: "" };
  return {
    period: rule.slice(0, match.index),
    value: rule.slice(match.index + match[0].length),
  };
};
